<template>
<div v-if="clubList">
    <div v-for="club in clubList"
         class="panel league row columns"
         v-bind:class="{ inactive: activatedLeague !== null && activatedLeague !== undefined && activatedLeague !== getLatestLeagueId(club) }"
         :id="club.id"
         @click="triggerLeague(club)">
        <div class="row columns">
        <img class="small-team-icon" :src="'https://back.bloodbowlclub.com' + club.icon_path" alt="team">
        </div>
    </div>
</div>
</template>

<script>
import store from '../store/index.js'
import { mapGetters } from 'vuex'

export default {
  name: 'leaguePanel',
  computed:
  {
    ...mapGetters([
      'activatedClub',
      'activatedLeague',
      'clubList'
    ])
  },
  created () {
    store.dispatch('getClubList')
  },
  methods: {
    getLatestLeagueId (club) {
      return club.leagues[club.leagues.length - 1].id
    },
    triggerLeague (club) {
      let leagueId = this.getLatestLeagueId(club)
      if (this.activatedLeague !== null &&
          this.activatedLeague === leagueId) {
        store.dispatch('deactivateLeague')
      } else {
        store.dispatch('activateLeague', leagueId)
      }
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
img {
    width: 40px;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
}

.league {
    -webkit-transition: opacity 0.35s, -webkit-transform 0.35s;
    transition: opacity 0.35s, transform 0.5s;
    cursor: pointer;
}
.league:hover {
	-webkit-transform: scale3d(1.1,1.1,1);
	transform: scale3d(1.1,1.1,1);
    box-shadow: 1px 1px 3px rgba(0,0,0,0.7)
}

.inactive {
    background-color: #E9EBEE;
}

</style>




// WEBPACK FOOTER //
// league-panel.vue?3c89ca3d